'use strict';

var dateFnsTz = require('date-fns-tz');
var constants = require('../constants.cjs');
var getSystemTimeZone = require('./getSystemTimeZone.cjs');

function formatInUtc(date, timeZoneParam, formatStringParam) {
  const systemTimeZone = getSystemTimeZone();
  const timeZone = timeZoneParam ?? systemTimeZone;
  const utcDate = dateFnsTz.zonedTimeToUtc(date, timeZone);
  const formatString = formatStringParam ?? constants.ISO_DATE_TIME_PART_FORMAT;
  return dateFnsTz.formatInTimeZone(utcDate, "UTC", formatString);
}

module.exports = formatInUtc;
//# sourceMappingURL=formatInUtc.cjs.map
